export interface syncState {
    syncSystem: ISyncSystem[],
    syncSystemFiltered: ISyncSystem[],
	syncSystemPageIndex: number,
    syncSystemPageSize: number,
    syncSystemFilteredPageIndex: number,
    syncSystemFilter: string,
    syncSystemsIsBusy: boolean,
    syncSystemsAtEnd: boolean,
    syncSystemTemplate: ISyncSystem,
    serverTypesCanSync: IServerTypes[],
    siteEntryTemplate: ISyncEntry,
    dynamicDataList: ITaskDynamicDataTypes[],
    requiredSyncEntriesStatusChecked: ISyncEntry[],
    syncTypes: ISyncType[],
    syncEntries: ISyncEntry[],
    syncEntryPageIndex: number,
    syncEntryPageSize: number,
    syncEntryIsBusy: boolean,
    syncEntryAtEnd: boolean,
    userErrorMessage: string,
    syncEntryFilteredPageIndex: number,
    syncEntriesFiltered: ISyncEntry[],
    syncEntryFilter: string
}

export interface ISyncSystem {
	extraValue: string,
    groupId: number,
    host: string,
    password: string,
    port: number,
    serverTypeId: number | null,
    syncSystemId: number,
    title: string,
    username: string,
    syncEntriesCount: number,
    canSyncDynamicDataList?: boolean
}

export interface IServerTypes {
    canSync: boolean,
    title: string,
    serverTypeID: number
}

export interface ISyncEntry {
    syncSystemTitle: string,
    groupSyncId: number,
    groupId: number | null,
    syncSystemId: number | null,
    identifier: string | null,
    enabled: boolean,
    lastUpdated: string | null,
    syncStarted: string | null,
    syncTypeId: number | null,
    dynamicDataTypeId: number | null
}

export interface ITaskDynamicDataTypes {
    dataTypeId: number,
    name: string
}

export interface ISyncType {
    syncTypeId: number,
    title: string
}

export interface IQuerySync {
    index: number,
    pageSize: number,
    filter: string
}

export enum SyncTypes {
    device = 1,
    dynamicDataList = 2
}